import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  skeletonContainer: {
    width: '100%'
  },
  skeleton: {
    width: '100%',
    height: 60,
    marginBottom: 20
  },
  skeletonRow: {
    width: '100%',
    height: 40
  },
  root: {
    position: 'relative',
    width: '100%'
  }
}))

export default useStyles
